import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { getCompanyBranch } from "../../../services/apis/company";
import DataTable from "../../../component/element/table";
import { ColumnDef } from "@tanstack/react-table";
import { ICompanyBranch } from "@/src/store/types/company";

type IBranches = {
  companyId?: string;
};

const CompanyBranch: React.FC<IBranches> = ({ companyId }) => {
  const dispatch = useAppDispatch();

  // 👇 this will come from your company reducer
  const branches = useAppSelector(({ company }) => company.branches);

  // Fetch branches when companyId changes
  useEffect(() => {
    if (companyId) {
      getCompanyBranch(companyId, dispatch);
    }
  }, [companyId, dispatch]);

  const columns: ColumnDef<ICompanyBranch>[] = [
    {
      accessorKey: "company_address",
      header: () => <span>Address</span>,
    },
    {
      accessorKey: "phone_number",
      header: () => <span>Phone</span>,
    },
    {
      accessorKey: "state.country.name",
      header: () => <span>Country</span>,
    },
    {
      accessorKey: "state.name",
      header: () => <span>State</span>,
    },
    {
      accessorKey: "status",
      header: () => <span>Status</span>,
    },
  ];

  return <DataTable columns={columns} data={branches || []} />;
};

export default CompanyBranch;
